import reduxStore from "../reduxStore";
import backgroundActions from '../reusable/BackgroundMessage/redux/BackgroundMessages.actions';

const deliveryUtils = {
    dispatchSuccessMessage(message) {
        reduxStore.dispatch(backgroundActions.clearBackgroundMessages());
        reduxStore.dispatch(backgroundActions.setSuccessBackgroundMessages(message));
    },

    dispatchProcessingMessage(message) {
        reduxStore.dispatch(backgroundActions.clearBackgroundMessages());
        reduxStore.dispatch(backgroundActions.setProcessingBackgroundMessages(message));
    },

    dispatchErrorMessage(message) {
        reduxStore.dispatch(backgroundActions.setFailureBackgroundMessages(message));
    }
};

export default deliveryUtils;


// WEBPACK FOOTER //
// ./src/scripts/utils/deliveryUtils.js